import { t } from "@bezbolisno/i18n";
import { can } from "@bezbolisno/kit/rbac";
import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { GiftsScreen } from "../../../screens/gifts/gifts-screen";
import { giftListQuery } from "../../../screens/gifts/queries";
import { LoadErrorScreen } from "../../../screens/invoices/shared";

const Search = z.object({
  q: z.string().optional().catch(undefined),
  page: z.number().int().min(1).optional().catch(undefined),
  new: z.string().optional().catch(undefined),
});

const filtersOf = (s: z.infer<typeof Search>) => ({ q: s.q || undefined, page: s.page ?? 1 });

export const Route = createFileRoute("/_authed/gifts/")({
  validateSearch: Search,
  beforeLoad: ({ context, search }) => {
    if (!can(context.session.role, "gift:manage")) throw redirect({ to: "/" });
    // The old `?new=1` entry point still lands on the creation page.
    if (search.new === "1") throw redirect({ to: "/gifts/new" });
  },
  loaderDeps: ({ search }) => filtersOf(search),
  loader: ({ context, deps }) => context.queryClient.ensureQueryData(giftListQuery(deps)),
  errorComponent: () => <LoadErrorScreen title={t.gifts.title} />,
  component: GiftsRoute,
});

function GiftsRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate();
  return (
    <GiftsScreen
      filters={filtersOf(search)}
      onSearch={(q) =>
        navigate({ to: "/gifts", search: { q: q || undefined, page: undefined, new: undefined } })
      }
    />
  );
}
